import { Center, Stack, Text, Button } from '@mantine/core';
import { useRouteError } from 'react-router-dom';

export function ErrorFallback() {
  const error = useRouteError();

  return (
    <Center h="70vh">
      <Stack align="center" gap="md">
        <Text c="red" fw={700} size="lg">
          Unexpected Application Error
        </Text>
        <Text c="dimmed">{error instanceof Error ? error.message : String(error)}</Text>
        <Button onClick={() => window.location.reload()} color="red" variant="outline">
          Reload Page
        </Button>
      </Stack>
    </Center>
  );
}
